import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from 'src/app/config/endpoints.config';
import { IMstHTOrg } from 'src/app/models/mstHTOrg.interface';

@Injectable({
  providedIn: 'root'
})
export class SrcInsuranceSelService {
  constructor(private http: HttpClient) { }
  GetMstHTOrg(pHTOrg: any) {
    return this.http.post<IMstHTOrg>(EndpointsConfig.common.getMstHTOrg,pHTOrg);
  }
}
